import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { Clamp, Relay, Probe, Pilotwire, Flowmeter, Airzone } from '.';
import ModulesForm from '../Product/Fhe/SDM19INL/components/ModulesForm';

class ProductModuleDetail extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        productIdentifier: PropTypes.string,
        productType: PropTypes.string,
        lineType: PropTypes.string,
        isSDM19INL: PropTypes.bool,
        key: PropTypes.string
    };

    static defaultProps = {
        isSDM19INL: false,
        productIdentifier: null,
        productType: null,
        lineType: null,
        key: null
    };

    render() {
        const { lineType, isSDM19INL } = this.props;

        if (isSDM19INL) {
            return <ModulesForm {...this.props} />;
        }

        const detailContentByType = {
            airzone: () => <Airzone {...this.props} />,
            clamp: () => <Clamp {...this.props} />,
            probe: () => <Probe {...this.props} />,
            pilotwire: () => <Pilotwire {...this.props} />,
            flowmeter: () => <Flowmeter {...this.props} />,
            relay: () => <Relay {...this.props} />,
            default: () => null
        };
        return (detailContentByType[lineType] || detailContentByType['default'])();
    }
}

export default withRouter(renderEnvComponent('scenes/Products/components/ProductModule/ProductModuleDetail', withTheme(ProductModuleDetail)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/ProductModule/ProductModuleDetail.js